import styled from 'styled-components';
import DeleteIconSvg from '../assets/hotels/review/delete-1.svg';

const DeleteIcon = styled(DeleteIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.color};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default DeleteIcon;
